import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { createBrowserRouter, Link, RouterProvider } from "react-router";
import { PageShell } from "./components/PageShell/PageShell";
import { StatusScreen } from "./components/StatusScreen/StatusScreen";
import { Home } from "./routes/home/Home";

const NotFound = () => (
  <PageShell centered>
    <StatusScreen title="Page not found" message="That page doesn't exist.">
      <Link to="/" className="btn btn-primary">
        Go to home
      </Link>
    </StatusScreen>
  </PageShell>
);

const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/r/:slug", lazy: async () => ({ Component: (await import("./routes/room/RoomPage")).RoomPage }) },
  { path: "*", element: <NotFound /> },
]);

const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: 1 },
      mutations: { retry: false },
    },
  });

export const App = () => {
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
};
